import { t } from '../../../i18next';
import type { ProcessDeletedRowsResult } from './processDeletedRows';

export function getDeleteErrorMessage(deleteResult: ProcessDeletedRowsResult): string {
  const errorMessage = deleteResult?.errorMessage ?? undefined;

  if (errorMessage === 'deletion_already_requested_pending') {
    return t('npiSteering.deletion_already_requested_pending');
  }

  if (errorMessage === 'delete_not_allowed_for_role') {
    return t('npiSteering.deletion_request_not_allowed');
  }

  return t('npiSteering.insert_upsert_error', {
    htz: 'data',
    msg: errorMessage ?? 'Delete processing failed',
  });
}
